import ar from "./ar.js";
import {getCookie} from "../utils/utils";

const translationsFormat = function (str, args) {
    if (!str) return str;
    let unkeyed_index = 0;
    return str.replace(/\{(\w*)\}/g, function (match, key) {
        if (key === '') {
            key = unkeyed_index;
            unkeyed_index++
        }
        if (key == +key) {
            return args[key] !== undefined
                ? args[key]
                : match;
        }
    }.bind(this));
}

const translations = {
    __(text, replace = undefined) {
        let lang = lms_website.current_language;
        if (lms_website.ar_translations && lms_website.ar_translations.length && lang === 'ar') {
            lms_website.ar_translations.map((translation) => {
                lms_website.language_messages[translation.source_text] = translation.translated_text;
            });
        }
        let messages = (lang === 'ar') ? {...lms_website.boot.__messages, ...ar, ...lms_website.language_messages} : {};
        if (lang) {
            let string = (messages[text] && $.trim(messages[text])) ? messages[text] : text;
            if (replace && typeof replace === "object") {
                string = translationsFormat(string, replace);
            }
            return string;
        } else {
            let string = text;
            if (replace && typeof replace === "object") {
                string = translationsFormat(string, replace);
            }
            return string;
        }
    }
};

export default translations;
